// Read hook: findings (each carrying its transaction `referenceNo` link).
//
// Role-scoped like useTransactions (owner feedback point 7): admins read all via
// the SDK; everyone else gets only their own allocations' findings through the
// server-scoped proxy. Shares the scoped query key with the other read hooks.
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../lib/queryKeys';
import { fetchFindings, fetchMyRegister, type ScopedRegister, type FindingRead } from '../lib/db';
import { useAuth } from '../lib/auth';

export function useFindings() {
  // Real role drives the fetch (admin = full read; the page scopes the view).
  const { realRole, user } = useAuth();
  const isAdmin = realRole === 'admin';
  const email = user?.email ?? '';
  return useQuery<FindingRead[] | ScopedRegister, Error, FindingRead[]>({
    queryKey: isAdmin ? queryKeys.findings : queryKeys.scopedRegisterFor(email),
    queryFn: isAdmin ? fetchFindings : fetchMyRegister,
    select: (d) => (isAdmin ? (d as FindingRead[]) : (d as ScopedRegister).findings),
    enabled: isAdmin || (!!realRole && email.length > 0),
  });
}
